const BASE = import.meta.env.VITE_API_BASE_URL || "";

export async function meQuery(): Promise<boolean> {
  const r = await fetch(`${BASE}/auth/me`, { credentials: "include" });
  if (!r.ok) return false;
  const j = (await r.json()) as { authenticated: boolean };
  return j.authenticated === true;
}

export async function loginRequest(password: string): Promise<boolean> {
  const r = await fetch(`${BASE}/auth/login`, {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ password }),
  });
  return r.ok;
}

export async function logoutRequest(): Promise<void> {
  await fetch(`${BASE}/auth/logout`, {
    method: "POST",
    credentials: "include",
  });
}
